import React from "react";
import {Constants} from "./Constants";

interface LoadingIndicatorProps {
    additionalClasses?: string;
}

export let LoadingIndicator = function (props: LoadingIndicatorProps) {
    return (
        <img
            className={`loading-indicator ${props.additionalClasses || ''}`}
            src={Constants.loadingIndicatorSrc}
        />
    )
};
